import {RetryLink} from '@apollo/client/link/retry';

export const createRetryLink = () => new RetryLink({
   delay: {
      initial: 3000,
      max: 60000,
      jitter: true
   },
   attempts: {
      max: 10,
      retryIf: (error, operation) => !!error && !operation.getContext().skipRetry
   }
});
